/**
 * Selector to return the percentage completion of a question.
 */

import { createSelector } from 'reselect';

import questionsLengthSelector from './questionsLengthSelector';
import questionsCompletedLengthSelector from './questionsCompletedLengthSelector';

export default createSelector(
  [questionsLengthSelector, questionsCompletedLengthSelector],
  (questionsLength, questionsCompletedLength) => Math.round((questionsCompletedLength / questionsLength) * 100),
);
